import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types'

export const Toggle = ({
                           side,
                           size,
                           field,
                           checked,
                           callBack,
                           enabled,
                           children,
                       }) => {

  const toggleSide = side || 'left';
  const toggleSize = size || 'big';

  const handleChange = (e) => {
    if (!enabled) return;

    callBack(e.target.checked, field);
  }

  return (
    <label
      htmlFor={field}
      className={`toggle ${toggleSide} ${toggleSize} ${checked ? 'checked' : ''} ${!enabled ? 'disabled' : ''}`}
    >
      {toggleSide === 'right' && <span className="label">{children}</span>}
      <div className="toggleBlock">
        <div className="togglePin" />
      </div>
      {toggleSide === 'left' && <span className="label">{children}</span>}

      <input
        type="checkbox"
        id={field}
        checked={checked}
        disabled={!enabled}
        onChange={handleChange}
      />
    </label>
  )
}


Toggle.propTypes = {
  side: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.oneOf(['big', 'small']),
  field: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  callBack: PropTypes.func,
  enabled: PropTypes.bool,
  children: PropTypes.node,
}

Toggle.defaultProps = {
  side: 'left',
  size: 'big',
  field: '',
  checked: false,
  callBack: (checked, field) => undefined,
  enabled: true,
  children: null,
}
